<template>
  <div id="find-pathfinder">
    <!-- INPUT -->
    <div
      class="search"
      v-if="state === 'inputing'"
    >
      <img
        src="@/assets/icons/wilderverse.png"
        class="wilderverse"
      >
      <p class="notice">SEARCH FOR YOUR PATHFINDER</p>
      <div
        class="alert"
        v-if="message !== ''"
      >
        {{ message }}
      </div>
      <input
        type="text"
        class="primary"
        onfocus="this.placeholder=''"
        onblur="this.placeholder='TYPE THEIR NAME'"
        v-model="name"
        v-focus
      >
      <button
        class="button primary"
        @click="find()"
      >FIND</button>
    </div>

    <!-- RESULTS -->
    <div
      class="results"
      v-if="state === 'choosing'"
    >
      <b-loading
        :is-full-page="true"
        :active.sync="loading"
        :can-cancel="false"
      ></b-loading>
      <img
        src="@/assets/icons/wilderverse.png"
        class="wilderverse"
      >
      <p>SELECT YOUR PATHFINDER</p>
      <div
        class="pathfinders"
        v-if="foundPathfinders && foundPathfinders.length > 0"
      >
        <avatar
          class="pathfinder"
          v-for="pathfinder in foundPathfinders"
          :key="pathfinder.id"
          :pathfinder="pathfinder"
          :hideName="true"
          @click.native="choose(pathfinder.name)"
        ></avatar>
      </div>
    </div>

    <!-- WRONG ANSWER -->
    <div
      class="wrong-answer"
      v-if="state === 'wrong'"
    >
      <p class="header">HMMMMMM...</p>
      <p class="notice">It doesn't seem like you had a great connection with your Pathfinder.</p>
      <button
        class="button primary"
        @click="$router.push({name: 'new'})"
      >CREATE A NEW PATHFINDER</button>
    </div>
  </div>
</template>

<script>
  import Avatar from "@/components/Pathfinder/Avatar.vue";
  import { mapActions, mapState } from "vuex";
  export default {
    data() {
      return {
        //  Possible ["inputing" => "choosing" => "wrong"]
        state: "inputing",
        name: "",
        message: "",
        loading: false,
        foundPathfinders: null
      };
    },
    components: { Avatar },
    methods: {
      ...mapActions([
        "setCurrentPathfinder",
        "savePathfinderToDevice",
        "searchPathfindersByName",
        "getRandomPathfinders"
      ]),
      choose(name) {
        if (this.name === name) {
          let found = this.foundPathfinders.find(p => p.name === name);
          this.setCurrentPathfinder(found);
          this.savePathfinderToDevice(found);
          this.$router.push({ name: "location" });
        } else {
          this.state = "wrong";
        }
      },
      find() {
        if (this.name === "") {
          this.message = "Please input a name to search for.";
          setTimeout(() => {
            this.message = "";
          }, 3000);
        } else {
          this.state = "choosing";
          this.loading = true;
          this.searchPathfindersByName({ name: this.name, addRandom: true }).then(
            pathfinders => {
              if (pathfinders.find(p => p.name === this.name)) {
                this.foundPathfinders = pathfinders;
              } else {
                this.state = "wrong";
              }

              this.loading = false;
            }
          );
        }
      }
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";

  #find-pathfinder {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;

    @include jungle-background();

    .wilderverse {
      margin-bottom: 1.25em;
      width: 85%;
    }

    .notice {
      filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.75));
    }

    .search {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      .alert {
        color: $primary;
      }

      input,
      button,
      p {
        width: 85%;
        margin-bottom: 1.25em;
      }

      p {
        color: $secondary;
        text-align: center;
      }
    }

    .results {
      width: 100%;
      height: 100%;

      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        text-align: center;
        color: white;
        font-size: 1.25em;
        font-weight: bold;
      }

      .pathfinders {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;

        .pathfinder {
          width: 40%;
          margin: auto;
        }
      }
    }

    .wrong-answer {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .header {
        font-weight: bold;
        font-size: 1.5em;
        margin-bottom: 2em;
      }

      .notice {
        width: 85%;
        margin-bottom: 6em;
        text-align: center;
      }

      button {
        white-space: normal;
        width: 85%;
        height: 4.5em;
      }
    }

    @media only screen and (min-width: 600px) {
      .wilderverse {
        width: 65%;
        margin-bottom: 5em;
      }

      .results {
        p {
          font-size: 2em;
        }
      }
    }
  }
</style>
